import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success('Login effettuato con successo!');
      navigate('/admin/dashboard');
    } else {
      toast.error(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-6" data-testid="admin-login-page">
      <Card className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="text-primary" size={32} />
          </div>
          <h1 className="font-serif text-3xl font-semibold mb-2" data-testid="admin-login-title">Admin Login</h1>
          <p className="text-foreground/60">Chichi in Viaggio</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full"
              data-testid="admin-login-password"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-full py-6"
            data-testid="admin-login-submit"
          >
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </Button>
        </form>

        <div className="mt-8 text-center">
          <a
            href="/"
            className="text-sm text-foreground/60 hover:text-foreground transition-colors"
            data-testid="back-to-site-link"
          >
            ← Torna al sito
          </a>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;